import script from "./AuthorCategoryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorCategoryCard.vue?vue&type=script&setup=true&lang=js"

import "./AuthorCategoryCard.vue?vue&type=style&index=0&id=a8449706&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8449706"]])

export default __exports__